import { HTTPVerbs, type RequestOptions } from '@nextgen-web-framework/core';
import { Get_PostPurchase_API_Version } from './postpurchaseApiConstants';

const headers = {
  'Content-Type': 'application/json',
};

export const getPostPurchaseReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders`,
  params: {},
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const getOrderDataReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/order-confirm`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const getSearchOrderReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/search`,
  params: {},
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const downloadOrdersReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/reports/orders/search`,
  params: {},
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const getSearchReturnOrderReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/returns/search`,
  params: {},
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const getOrderHistoryReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const getOrderDetailsReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const getOrderCancellationReasonsReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/reasons`,
  params: { query: 'EligibleForSelfService=true', reasonType: 'Cancel', size: '100' },
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const getReturnReasonsReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/reasons`,
  params: { query: 'EligibleForSelfService=true', reasonType: 'Return', size: '100' },
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const orderCancellationReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/order-cancel`,
  params: {},
  method: HTTPVerbs.PUT,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const returnCancellationReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/return-cancel`,
  params: {},
  method: HTTPVerbs.PUT,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const createReplacementDraftReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/replacements`,
  params: {},
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const createReplacementReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/replacements`,
  params: {},
  method: HTTPVerbs.PUT,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const createReturnDraftReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/returns`,
  params: {},
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const createReturnReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/returns`,
  params: {},
  method: HTTPVerbs.PUT,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const getReturnNumberReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/next-numbers`,
  params: { count: '1', counterType: 'GenerateReturnOrderId' },
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const getReplacementNumberReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/next-numbers`,
  params: { count: '1', counterType: 'GenerateExchangeOrderId' },
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const orderReplacementEligibleReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/replacement-eligible-items`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const orderReturnEligibleReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/return-eligible-items`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const orderReturnDetailsReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/returns`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const orderReturnDataReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/returns`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const orderReplacementDataReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/replacement`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const returnOrderImagesUploadReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/images/upload`,
  params: {},
  method: HTTPVerbs.POST,
  retries: 0,
  timeout: 30000,
};

export const returnOrderImagesRetrieveReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/images/retrieve`,
  params: {},
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const returnOrderImagesDeleteReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/images/delete`,
  params: {},
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const getReturnHistoryReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/returns`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const getLatamDeliveryTrackingReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 30000,
};

export const getDeliveryTrackingReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/track-delivery`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 30000,
};

export const getAnonymousDeliveryTrackingReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/anonymous-track-delivery`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 30000,
};
export const getPacakgeDetailsReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const getInvoiceDocumentReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/orders/invoices`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const managePackageActionReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}`,
  params: {},
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const saveOrdersPrintStatusReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/packages/printStatus`,
  params: {},
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
  timeout: 12000,
};

export const getOrdersPrintStatusReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/packages/getPrintStatus`,
  params: {},
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const getProductConditionsReqObj: RequestOptions = {
  url: `/comorderas/${Get_PostPurchase_API_Version}/returns/item-conditions`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};
